/* eslint-disable @typescript-eslint/no-unused-vars */
import classNames from "classnames";
import useBreakpoints from "hooks/useBreakpoints";
import { useImagePath } from "hooks";
import {
	CardStyled,
	Img,
	Body,
	Title,
	Description,
	Img2,
	ImagesContainer
} from "./styles";
import { LearnMoreItem } from "../../items";
import { useMediaPreloader } from "hooks/useMediaPreloader";

interface CardProps {
	item: LearnMoreItem;
}

export const Card: React.FC<CardProps> = ({ item }) => {
	const { isSmDown } = useBreakpoints();
	const { image, image2, description, title } = item;
	const { getImage } = useImagePath("local");

	const { isMediaLoaded: isBackgroundLoaded } = useMediaPreloader(
		getImage(image)
	);

	return (
		<CardStyled
			className={classNames([isSmDown && "mobile", !isSmDown && "landscape"])}
		>
			<ImagesContainer>
				{<Img className="image" src={getImage(image)} />}
				{isBackgroundLoaded && <Img2 className="image" src={image2} />}
			</ImagesContainer>

			<Body className="body">
				<Title className="title">{title}</Title>
				<Description className="description">{description}</Description>
			</Body>
		</CardStyled>
	);
};
